import ShareDialog from "./views/ShareDialog";

const routes = [
  {
    path: "/share",
    name: "share",
    component: ShareDialog,
    props: route => ({
      dialogAction: route.query.dialogAction,
      currentState: route.query.currentState,
      fileUid: route.query.fileUid,
      origin: route.query.origin,
    })
  }
];

export default routes;
